<template>
  <div class="box-login">
    <el-form ref="elForm" class="portal-form" :rules="rules" :model="form">
      <el-form-item prop="account">
        <el-input v-model="form.account" placeholder="请输入您的用户名/手机号" />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          class="pwd-input"
          type="password"
          placeholder="请输入您的用户密码"
          @keyup.enter.native="onLogin"
        />
      </el-form-item>
      <el-form-item prop="captchaKey" class="slider-validation">
        <FatImageVerification
          :request="requestVerificationMetadata"
          style="max-width: 100%"
          @change="handleVerificationChange"
        />
      </el-form-item>
    </el-form>
    <!-- <div class="forget-tip">
      <a @click="onForget">忘记密码？</a>
    </div> -->
    <el-button type="primary" class="btn-ok" @click="onLogin">登&nbsp;&nbsp;录</el-button>
    <!-- <div class="register">
      <a @click="onJoin">注册账号</a>
    </div> -->
  </div>
</template>

<script>
import loginMixin from './login';
import baseApi from '@/dss-common/api/base';
import { FatImageVerification } from '@wakeadmin/components';

const base64ToDataUrl = (url) => {
  return `data:image/jpeg;base64,${url}`;
};

export default {
  components: {
    FatImageVerification,
  },
  mixins: [loginMixin],
  data() {
    return {
      imgData: null,
      form: {
        loginType: 1,
        password: '',
        account: '',
        x: 0,
        y: 0,
        captchaKey: '',
      },
      rules: {
        password: {
          required: true,
          message: '请输入您的用户密码',
        },
        account: {
          required: true,
          message: '请输入您的用户名/手机号',
        },
        captchaKey: {
          required: true,
          message: '请完成滑块验证',
        },
      },
    };
  },
  methods: {
    async requestVerificationMetadata() {
      const { success, data } = await baseApi.queryVerifyCode({ type: 'slide' });
      if (success && data) {
        return {
          backgroundImage: base64ToDataUrl(data.shadeImage),
          clipImage: base64ToDataUrl(data.cutoutImage),
          y: data.y,
          extra: data,
        };
      } else {
        throw new Error('获取滑动验证码失败');
      }
    },
    handleVerificationChange(evt) {
      console.log(evt);
      this.form.x = evt.value;
      this.form.y = evt.context.y;
      this.form.captchaKey = evt.context.extra.redisKey;
    },
    onForget() {
      this.$emit('forget');
    },
    onLogin() {
      this.$refs.elForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.login(this.form);
      });
    },
    onJoin() {
      window.top.location.href = '/join.html';
    },
  },
};
</script>

<style lang="less">
.box-login {
  .slider-validation {
    .el-form-item__content {
      height: 194px;
      border: none;
    }
  }
  .forget-tip {
    font-size: 14px;
    color: #999999;
    height: 20px;
    line-height: 20px;
    text-align: right;
    margin: -14px 0 34px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
  }
  .register {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: right;
    color: #999999;
    line-height: 20px;
    margin-top: 8px;
  }
  .btn-ok {
    width: 308px;
    height: 54px;
    background: #2e8dff;
    border-radius: 4px;
    span {
      width: 54px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: right;
      color: #ffffff;
      line-height: 28px;
    }
  }
}
</style>
